import { Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { WARRANTY_STEP } from "../../common/constant";
import IDistrict from "../../models/districtModel";
import IProvince from "../../models/provinceModel";
import IWard from "../../models/wardModel";
import {
  selectInfoWarranty,
  warrantyActions,
} from "../../redux/reducers/slice/warranty";
import { getDistricts, getProvinces, getWards } from "../../services/common";
import { isEmail, isPhoneNumber, isRequired } from "../fields/validator";
import MyInput from "../input/input";
// import Input from "../input/input";
import "./infoCustomerStyle.scss";
const InformationCustomer = (props: any) => {
  const { step } = props;
  const { t } = useTranslation();
  const infoWarranty = useSelector(selectInfoWarranty);
  const dispatch = useDispatch();

  const [provinceOptions, setProvinceOptions] = useState<any>(null);

  const [districtOptions, setDistrictOptions] = useState<any>(null);

  const [wardOptions, setWardOptions] = useState<any>(null);

  useEffect(() => {
    if (step !== WARRANTY_STEP.CONFIRM) {
      getProvinces((cb) => {
        if (cb) {
          setProvinceOptions(cb);
        }
      });

      if (infoWarranty?.customer_district_id) {
        getDistricts(infoWarranty?.customer_province_id, (cb) => {
          if (cb) {
            setDistrictOptions(cb);
          }
        });
      }
      if (infoWarranty?.customer_district_id) {
        getWards(infoWarranty?.customer_district_id, (cb) => {
          if (cb) {
            setWardOptions(cb);
          }
        });
      }
    }
  }, []);

  const handelOnChangeProvince = (provinceId: any) => {
    // setProvince(provinceId);
    getDistricts(provinceId, (cb) => {
      if (cb) {
        setDistrictOptions(cb);
      }
    });
  };

  const handelOnChangeDistrict = (districtId: any) => {
    // setDistrict(districtId);
    getWards(districtId, (cb) => {
      if (cb) {
        setWardOptions(cb);
      }
    });
  };

  const handleNext = (values: any) => {
    // e.preventDefault();

    // customer_name: data.name,
    // customer_email: data.email,
    // customer_district_id: data.district,
    // customer_address: data.street,
    // customer_id_number: data.identity_number,
    // customer_phone_no: data.phone_number,
    // customer_province_id: data.province,
    // customer_township_id: data.ward,
    // customer_full_address: data.full_address ? data.full_address : data.street

    const _formValues = values;

    let fullAddress = null;

    const currentWard = wardOptions.find(
      (item: IWard) => item.id === _formValues.customer_township_id
    );
    const currentDistrict = districtOptions.find(
      (item: IDistrict) => item.id === _formValues.customer_district_id
    );
    const currentProvince = provinceOptions.find(
      (item: IProvince) => item.id === _formValues.customer_province_id
    );

    fullAddress = `${
      _formValues.customer_address ? _formValues.customer_address + ", " : ""
    }`;
    fullAddress += `${
      currentWard && currentWard.displayName
        ? currentWard.displayName + ", "
        : ""
    }`;
    fullAddress += `${
      currentDistrict && currentDistrict.displayName
        ? currentDistrict.displayName + ", "
        : ""
    }`;
    fullAddress += `${
      currentProvince && currentProvince.displayName
        ? currentProvince.displayName
        : ""
    }`;

    dispatch(
      warrantyActions.setInfoWarranty({
        key: "customer_province_id",
        value: _formValues.customer_province_id,
      })
    );
    dispatch(
      warrantyActions.setInfoWarranty({
        key: "customer_district_id",
        value: _formValues.customer_district_id,
      })
    );
    dispatch(
      warrantyActions.setInfoWarranty({
        key: "customer_township_id",
        value: _formValues.customer_township_id,
      })
    );
    dispatch(
      warrantyActions.setInfoWarranty({
        key: "customer_address",
        value: _formValues.customer_address,
      })
    );
    dispatch(
      warrantyActions.setInfoWarranty({
        key: "customer_full_address",
        value: fullAddress,
      })
    );
    dispatch(
      warrantyActions.setInfoWarranty({
        key: "customer_name",
        value: _formValues.customer_name,
      })
    );
    dispatch(
      warrantyActions.setInfoWarranty({
        key: "customer_phone_no",
        value: _formValues.customer_phone_no,
      })
    );
    dispatch(
      warrantyActions.setInfoWarranty({
        key: "customer_email",
        value: _formValues.customer_email,
      })
    );

    props.setStep(4);
  };

  return (
    <>
      {step === WARRANTY_STEP.CONFIRM || step === WARRANTY_STEP.RESULT ? (
        <>
          <div className="customer-container">
            <div className="customer-title">
              {/* <span className="sub-title">&gt; </span> */}
              <li className="main-content">
                Thông tin khách hàng được bảo hành sản phẩm
              </li>
            </div>

            <div className="customer-info">
              <form className="customer-info__form">
                <MyInput
                  prefix="Họ và tên:"
                  name="customer_name"
                  defaultValue={infoWarranty?.customer_name}
                  disabled
                />
                <MyInput
                  prefix="Điện thoại:"
                  name="customer_phone_no"
                  defaultValue={infoWarranty?.customer_phone_no}
                  disabled
                />
                <MyInput
                  prefix="Email:"
                  name="customer_email"
                  defaultValue={infoWarranty?.customer_email}
                  disabled
                />
                <MyInput
                  prefix="Địa chỉ:"
                  name="customer_full_address"
                  defaultValue={infoWarranty?.customer_full_address}
                  disabled
                />

                {step === WARRANTY_STEP.CONFIRM && (
                  <>
                    <div
                      className="btn warranty-customer-form__btn"
                      onClick={props.handleConfirm}>
                      <p className="btn__text sub-title">Xác nhận</p>
                    </div>
                    <div className="register__home" style={{ marginTop: 30 }}>
                      <a onClick={() => props.setStep(3)}>Quay lại</a>
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
        </>
      ) : (
        <>
          <p className="warranty__title main-title">
            Thông tin khách hàng
            <br />
            được bảo hành sản phẩm
          </p>

          <Form
            initialValues={{ ...infoWarranty }}
            autoComplete="off"
            className="warranty-customer-form kd-sign-up-form-content"
            id="warranty-customer-form"
            labelCol={{ span: 7 }}
            onFinish={handleNext}>
            <Form.Item
              className="kd-sign-up-form-item"
              name="customer_name"
              label={"Họ và tên:"}
              rules={[isRequired]}>
              <Input className="input" placeholder={"Nhập họ và tên"} />
            </Form.Item>
            <Form.Item
              className="kd-sign-up-form-item"
              name="customer_phone_no"
              label={"Điện thoại:"}
              rules={[isRequired, isPhoneNumber]}>
              <Input className="input" placeholder={"Nhập số điện thoại"} />
            </Form.Item>
            <Form.Item
              className="kd-sign-up-form-item"
              name="customer_email"
              label={"Email:"}
              rules={[isRequired, isEmail]}>
              <Input className="input" placeholder={"Nhập email"} />
            </Form.Item>
            <Form.Item
              className="kd-sign-up-form-item"
              name="customer_province_id"
              rules={[
                {
                  required: true,
                  message: t("customer_province_id_valid"),
                },
              ]}
              label={"Tỉnh/Thành phố"}>
              <Select
                showSearch
                placeholder={"Chọn tỉnh / thành phố"}
                optionFilterProp="children"
                onChange={(value) => handelOnChangeProvince(value)}
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input.toLowerCase()) >= 0
                }>
                {Array.isArray(provinceOptions) &&
                  provinceOptions.length &&
                  provinceOptions.map((item, i) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.displayName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              className="kd-sign-up-form-item"
              name="customer_district_id"
              rules={[
                {
                  required: true,
                  message: t("customer_district_id_valid"),
                },
              ]}
              label={"Quận / huyện"}>
              <Select
                aria-autocomplete="none"
                showSearch
                placeholder={"Chọn quận / huyện"}
                optionFilterProp="children"
                onChange={(value) => handelOnChangeDistrict(value)}
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input.toLowerCase()) >= 0
                }>
                {Array.isArray(districtOptions) &&
                  districtOptions.length &&
                  districtOptions.map((item, i) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.displayName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              className="kd-sign-up-form-item"
              name="customer_township_id"
              rules={[
                {
                  required: true,
                  message: t("customer_ward_id_valid"),
                },
              ]}
              label={"Phường / xã"}>
              <Select
                aria-autocomplete="none"
                showSearch
                placeholder={"Chọn phường / xã"}
                optionFilterProp="children"
                // onChange={(value) => setWard(value)}
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input.toLowerCase()) >= 0
                }>
                {Array.isArray(wardOptions) &&
                  wardOptions.length &&
                  wardOptions.map((item, i) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.displayName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              className="kd-sign-up-form-item"
              name="customer_address"
              label={"Địa chỉ:"}
              rules={[
                {
                  required: true,
                  message: t("customer_address_valid"),
                },
              ]}>
              <Input
                className="input"
                placeholder={"Nhập số nhà, đường, thôn, ấp..."}
              />
            </Form.Item>

            <button className="btn warranty-customer-form__btn" type="submit">
              <p className="btn__text sub-title">Tiếp tục</p>
            </button>
          </Form>
        </>
      )}{" "}
    </>
  );
};

export default InformationCustomer;
